<p>device-coverage works!</p>
